import { useEffect, useRef, useState } from "react";
import { Routes, Route } from "react-router-dom";
import { useSelector } from "react-redux";
import { Toaster } from "react-hot-toast";
import Api from "./services/api";
import emitter from "./services/emitter-service";
import { AddBlog } from "./containers/blogs/addBlog.js";
import { AddCaseStudy } from "./containers/caseStudies/addCaseStudy.js";
import { AddCourse } from "./containers/courses/addcourse";
import { AddFaq } from "./containers/faqs/addFaq.js";
import { AddSection } from "./containers/caseStudies/sections/addSection.js";
import { AddTeam } from "./containers/team/teamAdd/index.js";
import { AddUpdateJobs } from "./containers/jobs/addUpdate/index.js";
import { AddUpdatePolicy } from "./containers/bsPolicies/addUpdate/index.jsx";
import { AddUpdateTrainers } from "./containers/trainers/addUpdate/index.jsx";
import { AddVoucher } from "./containers/vouchers/addVoucher/index.js";
import { AdminUserRoles } from "./containers/users/adminRoles/index.js";
import { BlogDetails } from "./containers/blogs/blogInfo/index.js";
import { BlogsHome } from "./pages/blogs/index.js";
import { BulkUpdate } from "./containers/jobs/BulkUpdate/index.jsx";
import { BSPolicies } from "./pages/bsPolicies/index.jsx";
import { CandidateRequests } from "./containers/requests/candidate/index.js";
import { CategoryInfo } from "./containers/blogs/categories/categoryInfo.js";
import { CompanyFilters } from "./pages/companyFilters/index.jsx";
import { CompanyQueries } from "./pages/companyQueries/index.jsx";
import { Companies } from "./containers/jobs/companies/index.jsx";
import { ContactUs } from "./pages/actionList/index.js";
import { Course } from "./containers/courses/course";
import { CreateEmail } from "./containers/vouchers/generateEmail/createEmail.js";
import { Dashboard } from "./pages/dashboard/index.jsx";
import DeleteModal from "./components/termModal";
import { EditBlog } from "./containers/blogs/editBlog.js";
import { EditCaseStudy } from "./containers/caseStudies/editCaseStudy.js";
import { EditFaq } from "./containers/faqs/editFaq.js";
import { EditSection } from "./containers/caseStudies/sections/editSection.js";
import { EditTeam } from "./containers/team/teamEdit/index.js";
import { EmailDetails } from "./containers/vouchers/generateEmail/emailDetails.js";
import { EmployeeRequests } from "./containers/requests/employee/index.js";
import { ErrorLogs } from "./pages/errorLogs/index.js";
import { ExportRecords } from "./pages/exportRecords/index.jsx";
import { FaqCategoryInfo } from "./containers/faqs/categories/categoryInfo.js";
import { FaqDetails } from "./containers/faqs/faqInfo/index.js";
import { FaqPageInfo } from "./containers/faqs/pages/pageInfo.js";
import { FaqsHome } from "./pages/faqs/index.js";
import { GenerateEmail } from "./containers/vouchers/generateEmail/index.js";
import { HierarchyChart } from "./pages/hierarchyChart/index.jsx";
import { HomePage } from "./pages/homepage";
import { InfoHome } from "./containers/caseStudies/caseStudyInfo/index.js";
import { InfluencerFilters } from "./containers/influncers/filters/index.jsx";
import { InfluencersProfile } from "./containers/influncers/profiles/index.jsx";
import { JobApplication } from "./containers/jobs/jobApplication/index.jsx";
import { JobDetails } from "./containers/jobs/jobInfo/index.js";
import { Jobs } from "./containers/jobs/index.js";
import { JobsFilterUpdate } from "./containers/jobs/jobFilterUpdate/index.jsx";
import { KnowledgeBank } from "./containers/buyer/knowledgeBank/index.jsx";
import { LoginActivity } from "./containers/users/activeUsers/loginActivity/index.js";
import { LiveUsers } from "./containers/users/liveUsers/index.js";
import { Navbar } from "./components/navbar";
import { Newsletters } from "./pages/newsletters/index.js";
import { OurTeam } from "./pages/team/index.js";
import { PackageBased } from "./containers/courses/orders/packageBased/index.js";
import { Paid } from "./containers/vouchers/paid/index.js";
import { Pending } from "./containers/vouchers/pending/index.js";
import { PostedContent } from "./containers/influncers/PostedContent/index.jsx";
import { PriceTagSetting } from "./containers/influncers/priceSetting/index.jsx";
import { Processing } from "./containers/vouchers/processing/index.js";
import { ProtectedRoutes } from "./util/protectedRoutes";
import { QuestionDetails } from "./containers/users/overall/questionDetails/index.js";
import { ReportAbuse } from "./pages/reportAbuse/index.js";
import { Reports } from "./pages/reports/index.js";
import { SectionInfo } from "./containers/caseStudies/sections/sectionInfo.js";
import { ServerError } from "./pages/serverError/index.js";
import { SignInPage } from "./pages/signIn";
import SignOut from "./components/signoutModal";
import { SingleContent } from "./containers/influncers/SingleContent/index.jsx";
import { SystemSettings } from "./containers/influncers/SystemSettings/index.jsx";
import { TeamInfo } from "./containers/team/teamInfo/index.js";
import { Term } from "./pages/terms";
import { Trainers } from "./pages/trainners/index.jsx";
import { UserDetail } from "./containers/users/userDetail/index.js";
import { ViewApplicants } from "./containers/jobs/viewApplicants/index.jsx";
import { ViewCourses } from "./pages/viewCourses";
import { ViewUsers } from "./containers/jobs/ViewUsers/index.jsx";
import { Vouchers } from "./containers/vouchers/viewVouchers";
import { ActiveUsers } from "./containers/users/activeUsers/index.js";
import { AllTickets } from "./pages/tickets/index.js";
import { CaseStudies } from "./pages/caseStudies/index.js";
import { OverallUsers } from "./containers/users/overall/index.js";
import { Withdrawals } from "./containers/withdrawal/Withdrawals.jsx";
import { SurveyResponses } from "./pages/surveyResponses/index.jsx";

Api.init({
  url: `${process.env.REACT_APP_SERVER_URL}/api/admin`,
});

export const Router = () => {
  const { token, userInfo } = useSelector((store) => store.login);
  const [open, setOpen] = useState(false);

  if (token) {
    Api.setClientToken(token);
    Api.verifyResponse(token);
  }

  useEffect(() => {
    if (token) {
      Api.setClientToken(token);
      Api.verifyResponse(token);
    }
  }, [token]);

  const popupRef = useRef(null);
  const signOutRef = useRef(null);

  useEffect(() => {
    emitter.on("FinishPopUp", onDeletePopUp);
    emitter.on("SignOutPopUp", onSignOutPopUp);
  });

  const onDeletePopUp = (data) => {
    popupRef?.current?.open(data);
  };

  const onSignOutPopUp = () => {
    signOutRef?.current?.open();
    setOpen(false);
  };

  const protectedRoutesSuperAdmin = [
    { path: "*", element: <HomePage /> },
    { path: "/dashboard", element: <Dashboard /> },
    { path: "/policy/:policyname?", element: <Term /> },
    { path: "/blogs/:type?", element: <BlogsHome /> },
    { path: "/faqs/:type?", element: <FaqsHome /> },
    { path: "/team/add", element: <AddTeam /> },
    { path: "/blog/add", element: <AddBlog /> },
    { path: "/faq/add", element: <AddFaq /> },
    { path: "/team/:id", element: <TeamInfo /> },
    { path: "/blog/:id", element: <BlogDetails /> },
    { path: "/faq/:id", element: <FaqDetails /> },
    { path: "/jobs/view-all", element: <Jobs /> },
    { path: "/jobs/filter", element: <JobsFilterUpdate /> },
    { path: "/jobs/companies", element: <Companies /> },
    { path: "/jobs/bulk-update", element: <BulkUpdate /> },
    { path: "/jobs/detail/:id", element: <JobDetails /> },
    { path: "/tickets/view-all", element: <AllTickets /> },
    { path: "/companies/all", element: <Companies /> },
    { path: "/companies/queries", element: <CompanyQueries /> },
    { path: "/companies/filters", element: <CompanyFilters /> },
    { path: "/bs/policies", element: <BSPolicies /> },
    { path: "/team/edit/:id", element: <EditTeam /> },
    { path: "/blog/edit/:id", element: <EditBlog /> },
    { path: "/faq/edit/:id", element: <EditFaq /> },
    { path: "/jobs/:type/:id?", element: <AddUpdateJobs /> },
    { path: "/bs/hierarchy-chart", element: <HierarchyChart /> },
    { path: "/bs/policies/:type/:id?", element: <AddUpdatePolicy /> },
    { path: "/contents/team", element: <OurTeam /> },
    { path: "/contents/trainers", element: <Trainers /> },
    { path: "/contents/blogs/:type?", element: <BlogsHome /> },
    { path: "/contents/faqs/:type?", element: <FaqsHome /> },
    { path: "/contents/blog/add", element: <AddBlog /> },
    { path: "/contents/faq/add", element: <AddFaq /> },
    { path: "/contents/blog/:id", element: <BlogDetails /> },
    { path: "/contents/faq/:id", element: <FaqDetails /> },
    { path: "/contents/team/add", element: <AddTeam /> },
    { path: "/contents/team/:id", element: <TeamInfo /> },
    { path: "/contents/blog/edit/:id", element: <EditBlog /> },
    { path: "/contents/faq/edit/:id", element: <EditFaq /> },
    { path: "/contents/team/edit/:id", element: <EditTeam /> },
    { path: "/contents/trainers/:type/:id?", element: <AddUpdateTrainers /> },
    { path: "/offerings/:type", element: <ViewCourses /> },
    { path: "/users/list/:status", element: <ActiveUsers /> },
    { path: "/users/overall", element: <OverallUsers /> },
    { path: "/users/live-user", element: <LiveUsers /> },
    { path: "/users/user-detail/:id", element: <UserDetail /> },
    { path: "/jobs/all-applications", element: <ViewApplicants /> },
    { path: "/jobs/view-users/:id", element: <ViewUsers /> },
    { path: "/jobs/job-application/:id", element: <JobApplication /> },
    { path: "/jobs/view-applicants/:id", element: <ViewApplicants /> },
    { path: "/others/newsletters", element: <Newsletters /> },
    { path: "/others/export-records", element: <ExportRecords /> },
    { path: "/others/report-abuse", element: <ReportAbuse /> },
    { path: "/others/reports", element: <Reports /> },
    { path: "/others/error-logs", element: <ErrorLogs /> },
    { path: "/others/action-list", element: <ContactUs /> },
    { path: "/others/quote-requests", element: <ContactUs type={"rfq"} /> },
    {
      path: "/others/expert-hiring-form",
      element: <ContactUs type={"expert-hiring-form"} />,
    },
    {
      path: "/others/request-join-research",
      element: <ContactUs type={"request-join-research"} />,
    },
    { path: "/contents/case-studies", element: <CaseStudies /> },
    { path: "/contents/case-studies/add", element: <AddCaseStudy /> },
    { path: "/contents/case-studies/:id/:type", element: <InfoHome /> },
    { path: "/contents/case-studies/edit/:id", element: <EditCaseStudy /> },
    { path: "/contents/blogs/categories/:id", element: <CategoryInfo /> },
    { path: "/contents/faqs/categories/:id", element: <FaqCategoryInfo /> },
    { path: "/contents/faqs/pages/:id", element: <FaqPageInfo /> },
    { path: "/users/admin-user-roles", element: <AdminUserRoles /> },
    { path: "/users/question-details/:id", element: <QuestionDetails /> },
    { path: "/users/login-activity/:id", element: <LoginActivity /> },
    { path: "/jobs/candidate-request", element: <CandidateRequests /> },
    { path: "/jobs/employee-request", element: <EmployeeRequests /> },
    { path: "/influencers/profiles", element: <InfluencersProfile /> },
    { path: "/influencers/filters", element: <InfluencerFilters /> },
    { path: "/influencers/price-setting", element: <PriceTagSetting /> },
    { path: "/influencers/system-settings", element: <SystemSettings /> },
    { path: "/influencers/posted-content", element: <PostedContent /> },
    { path: "/influencers/posted-content/:id", element: <SingleContent /> },
    { path: "/buyer/knowledge-bank", element: <KnowledgeBank /> },
    { path: "/payment-request/orders", element: <PackageBased /> },
    { path: "/payment-request/pending", element: <Pending /> },
    { path: "/payment-request/paid", element: <Paid /> },
    { path: "/payment-request/vouchers", element: <Vouchers /> },
    { path: "/payment-request/add-voucher", element: <AddVoucher /> },
    { path: "/payment-request/all-emails", element: <GenerateEmail /> },
    { path: "/payment-request/processing", element: <Processing /> },
    { path: "/payment-request/view-voucher", element: <Vouchers /> },
    { path: "/payment-request/withdrawals", element: <Withdrawals /> },
    { path: "/survey/responses", element: <SurveyResponses /> },
    { path: "/payment-request/update-voucher/:id", element: <AddVoucher /> },
    { path: "/payment-request/email/:id", element: <EmailDetails /> },
    { path: "/payment-request/all-emails/generate", element: <CreateEmail /> },
    { path: "/offerings/:type/:title/*", element: <Course /> },
    { path: "/offerings/:offtype/action/:type/:id?", element: <AddCourse /> },
    {
      path: "/contents/case-studies/:id/sections/add",
      element: <AddSection />,
    },
    {
      path: "/contents/case-studies/:faqId/sections/:id",
      element: <SectionInfo />,
    },
    {
      path: "/contents/case-studies/:faqId/sections/edit/:id",
      element: <EditSection />,
    },
  ];

  const protectedRoutesAdmin = [
    { path: "*", element: <HomePage /> },
    { path: "/dashboard", element: <Dashboard /> },
    { path: "/policy/:policyname?", element: <Term /> },
    { path: "/jobs/view-all", element: <Jobs /> },
    { path: "/jobs/filter", element: <JobsFilterUpdate /> },
    { path: "/jobs/companies", element: <Companies /> },
    { path: "/jobs/bulk-update", element: <BulkUpdate /> },
    { path: "/jobs/detail/:id", element: <JobDetails /> },
    { path: "/jobs/:type/:id?", element: <AddUpdateJobs /> },
    { path: "/jobs/candidate-request", element: <CandidateRequests /> },
    { path: "/jobs/employee-request", element: <EmployeeRequests /> },
    { path: "/jobs/all-applications", element: <ViewApplicants /> },
    { path: "/jobs/view-users/:id", element: <ViewUsers /> },
    { path: "/jobs/view-applicants/:id", element: <ViewApplicants /> },
    { path: "/jobs/job-application/:id", element: <JobApplication /> },
    { path: "/offerings/:type/:title/*", element: <Course /> },
    { path: "/offerings/:offtype/action/:type/:id?", element: <AddCourse /> },
    { path: "/offerings/:type", element: <ViewCourses /> },
  ];

  return (
    <>
      <Navbar open={open} setOpen={setOpen} token={token} />
      <DeleteModal ref={popupRef} />
      <SignOut ref={signOutRef} />
      <Toaster />
      <div
        className={`mt-16 transition-all duration-200 overflow-hidden ease-in-out`}
      >
        <ServerError>
          <Routes>
            <Route path="/signin" element={<SignInPage />} />

            {userInfo?.ability === "Super-Admin"
              ? protectedRoutesSuperAdmin?.map((route, index) => {
                  return (
                    <Route
                      key={index}
                      path={route?.path}
                      element={
                        <ProtectedRoutes>{route?.element}</ProtectedRoutes>
                      }
                    />
                  );
                })
              : protectedRoutesAdmin?.map((route, index) => {
                  return (
                    <Route
                      key={index}
                      path={route?.path}
                      element={
                        <ProtectedRoutes>{route?.element}</ProtectedRoutes>
                      }
                    />
                  );
                })}
          </Routes>
        </ServerError>
      </div>
    </>
  );
};
